
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company } from '../store/company'
import Edit from './Edit.vue'

@Component({ components: { Edit } })
export default class DetailCompany extends Vue {
  @Prop() company!: Company

  close() {
    this.$emit('close')
  }
}
